import React from 'react';
import Profile from '../restaurant/Profile';
import EatsAdminLayout from './EatsAdminLayout';
import './EatsAdminDashboard.css';

const AppUserProfilePage = () => (
  <EatsAdminLayout activeTab="profile">
    <h2 className="eats-admin-dashboard__title">Profile</h2>
    <p className="eats-admin-dashboard__subtitle">
      Manage your account details and password for Maya Eats Business.
    </p>
    <Profile embedded />
  </EatsAdminLayout>
);

export default AppUserProfilePage;
